import React, { createContext, useContext, useState, useEffect } from "react";
import { authService } from "../services/authService";

const AuthContext = createContext();

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error("useAuth debe usarse dentro de un AuthProvider");
    }
    return context;
};

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [session, setSession] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // 1. Obtener la sesión inicial
        const initializeAuth = async () => {
            try {
                const initialSession = await authService.getSession();
                setSession(initialSession);
                setUser(initialSession?.user || null);
            } catch (err) {
                console.error("Error al obtener la sesión inicial:", err);
                setSession(null);
                setUser(null);
            } finally {
                setLoading(false);
            }
        };

        initializeAuth();

        // 2. Escuchar cambios de autenticación en tiempo real
        const subscription = authService.onAuthStateChange((_event, currentSession) => {
            setSession(currentSession);
            setUser(currentSession?.user || null);
            setLoading(false);
        });

        return () => subscription.unsubscribe();
    }, []);

    const signOut = async () => {
        try {
            await authService.signOut();
        } catch (error) {
            console.error("Error al cerrar sesión:", error);
        }
    };

    const value = {
        user,
        session,
        loading,
        signOut
    };

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
};
